// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file search/v2/search.proto (package search.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file search/v2/search.proto.
 */
export const file_search_v2_search: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChZzZWFyY2gvdjIvc2VhcmNoLnByb3RvEglzZWFyY2gudjIi4gIKBlJlc3VsdBIKCgJpZBgBIAEoCRIjCgR0eXBlGAIgASgOMhUuc2VhcmNoLnYyLlJlc3VsdFR5cGUSDgoGb3JnX2lkGAMgASgJEhQKDHdvcmtzcGFjZV9pZBgEIAEoCRIMCgRuYW1lGAUgASgJEhMKC2Rlc2NyaXB0aW9uGAYgASgJEhEKCWltYWdlX3VybBgHIAEoCRIjCgdjcmVhdG9yGAggASgLMhIuY29tbW9uLnYxLkNyZWF0b3ISEwoLZm9sZGVyX3BhdGgYCSABKAkSDAoEdGFncxgKIAMoCRINCgVzdGF0ZRgLIAEoCRIuCgpjcmVhdGVkX2F0GAwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GA0gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIUCgxhdXRvY29tcGxldGUYDiADKAkimwEKDVNlYXJjaFJlcXVlc3QSFAoMd29ya3NwYWNlX2lkGAEgASgJEg4KBm9yZ19pZBgCIAEoCRINCgVxdWVyeRgDIAEoCRIyCgpwYWdpbmF0aW9uGAQgASgLMh4uY29tbW9uLnYxLlBhZ2luYXRpb25Bcmd1bWVudHMSIQoGZmlsdGVyGAUgASgLMhEuc2VhcmNoLnYyLkZpbHRlciIXCgZGaWx0ZXISDQoFc3RhdGUYASABKAkiZgoOU2VhcmNoUmVzcG9uc2USIgoHcmVzdWx0cxgBIAMoCzIRLnNlYXJjaC52Mi5SZXN1bHQSMAoJcGFnZV9pbmZvGAIgASgLMh0uY29tbW9uLnYxLlBhZ2luYXRpb25QYWdlSW5mbyJKChNBdXRvY29tcGxldGVSZXF1ZXN0EhQKDHdvcmtzcGFjZV9pZBgBIAEoCRIOCgZvcmdfaWQYAiABKAkSDQoFcXVlcnkYAyABKAkiOgoUQXV0b2NvbXBsZXRlUmVzcG9uc2USIgoHcmVzdWx0cxgBIAMoCzIRLnNlYXJjaC52Mi5SZXN1bHQqWQoKUmVzdWx0VHlwZRIbChdSRVNVTFRfVFlQRV9VTlNQRUNJRklFRBAAEhUKEVJFU1VMVF9UWVBFX1NVSVRFEAESFwoTUkVTVUxUX1RZUEVfQ09OVEFDVBACMq8BCg1TZWFyY2hTZXJ2aWNlEkUKBlNlYXJjaBIYLnNlYXJjaC52Mi5TZWFyY2hSZXF1ZXN0Ghkuc2VhcmNoLnYyLlNlYXJjaFJlc3BvbnNlIgbC7RoCCAISVwoMQXV0b2NvbXBsZXRlEh4uc2VhcmNoLnYyLkF1dG9jb21wbGV0ZVJlcXVlc3QaHy5zZWFyY2gudjIuQXV0b2NvbXBsZXRlUmVzcG9uc2UiBsLtGgIIAmIGcHJvdG8z",
		[file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_timestamp],
	);

/**
 * @generated from message search.v2.Result
 */
export type Result = Message<"search.v2.Result"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: search.v2.ResultType type = 2;
	 */
	type: ResultType;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description: string;

	/**
	 * @generated from field: string image_url = 7;
	 */
	imageUrl: string;

	/**
	 * @generated from field: common.v1.Creator creator = 8;
	 */
	creator?: Creator;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 10;
	 */
	tags: string[];

	/**
	 * @generated from field: string state = 11;
	 */
	state: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: Timestamp;

	/**
	 * @generated from field: repeated string autocomplete = 14;
	 */
	autocomplete: string[];
};

/**
 * @generated from message search.v2.Result
 */
export type ResultJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: search.v2.ResultType type = 2;
	 */
	type?: ResultTypeJson;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description?: string;

	/**
	 * @generated from field: string image_url = 7;
	 */
	imageUrl?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 8;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 10;
	 */
	tags?: string[];

	/**
	 * @generated from field: string state = 11;
	 */
	state?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: repeated string autocomplete = 14;
	 */
	autocomplete?: string[];
};

/**
 * Describes the message search.v2.Result.
 * Use `create(ResultSchema)` to create a new message.
 */
export const ResultSchema: GenMessage<Result, { jsonType: ResultJson }> = /*@__PURE__*/ messageDesc(file_search_v2_search, 0);

/**
 * @generated from message search.v2.SearchRequest
 */
export type SearchRequest = Message<"search.v2.SearchRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string query = 3;
	 */
	query: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments;

	/**
	 * @generated from field: search.v2.Filter filter = 5;
	 */
	filter?: Filter;
};

/**
 * @generated from message search.v2.SearchRequest
 */
export type SearchRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string query = 3;
	 */
	query?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * @generated from field: search.v2.Filter filter = 5;
	 */
	filter?: FilterJson;
};

/**
 * Describes the message search.v2.SearchRequest.
 * Use `create(SearchRequestSchema)` to create a new message.
 */
export const SearchRequestSchema: GenMessage<SearchRequest, { jsonType: SearchRequestJson }> = /*@__PURE__*/ messageDesc(file_search_v2_search, 1);

/**
 * @generated from message search.v2.Filter
 */
export type Filter = Message<"search.v2.Filter"> & {
	/**
	 * @generated from field: string state = 1;
	 */
	state: string;
};

/**
 * @generated from message search.v2.Filter
 */
export type FilterJson = {
	/**
	 * @generated from field: string state = 1;
	 */
	state?: string;
};

/**
 * Describes the message search.v2.Filter.
 * Use `create(FilterSchema)` to create a new message.
 */
export const FilterSchema: GenMessage<Filter, { jsonType: FilterJson }> = /*@__PURE__*/ messageDesc(file_search_v2_search, 2);

/**
 * @generated from message search.v2.SearchResponse
 */
export type SearchResponse = Message<"search.v2.SearchResponse"> & {
	/**
	 * @generated from field: repeated search.v2.Result results = 1;
	 */
	results: Result[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message search.v2.SearchResponse
 */
export type SearchResponseJson = {
	/**
	 * @generated from field: repeated search.v2.Result results = 1;
	 */
	results?: ResultJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message search.v2.SearchResponse.
 * Use `create(SearchResponseSchema)` to create a new message.
 */
export const SearchResponseSchema: GenMessage<SearchResponse, { jsonType: SearchResponseJson }> = /*@__PURE__*/ messageDesc(file_search_v2_search, 3);

/**
 * @generated from message search.v2.AutocompleteRequest
 */
export type AutocompleteRequest = Message<"search.v2.AutocompleteRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string query = 3;
	 */
	query: string;
};

/**
 * @generated from message search.v2.AutocompleteRequest
 */
export type AutocompleteRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string query = 3;
	 */
	query?: string;
};

/**
 * Describes the message search.v2.AutocompleteRequest.
 * Use `create(AutocompleteRequestSchema)` to create a new message.
 */
export const AutocompleteRequestSchema: GenMessage<AutocompleteRequest, { jsonType: AutocompleteRequestJson }> = /*@__PURE__*/ messageDesc(file_search_v2_search, 4);

/**
 * @generated from message search.v2.AutocompleteResponse
 */
export type AutocompleteResponse = Message<"search.v2.AutocompleteResponse"> & {
	/**
	 * @generated from field: repeated search.v2.Result results = 1;
	 */
	results: Result[];
};

/**
 * @generated from message search.v2.AutocompleteResponse
 */
export type AutocompleteResponseJson = {
	/**
	 * @generated from field: repeated search.v2.Result results = 1;
	 */
	results?: ResultJson[];
};

/**
 * Describes the message search.v2.AutocompleteResponse.
 * Use `create(AutocompleteResponseSchema)` to create a new message.
 */
export const AutocompleteResponseSchema: GenMessage<AutocompleteResponse, { jsonType: AutocompleteResponseJson }> = /*@__PURE__*/ messageDesc(file_search_v2_search, 5);

/**
 * @generated from enum search.v2.ResultType
 */
export enum ResultType {
	/**
	 * @generated from enum value: RESULT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: RESULT_TYPE_SUITE = 1;
	 */
	SUITE = 1,

	/**
	 * @generated from enum value: RESULT_TYPE_CONTACT = 2;
	 */
	CONTACT = 2,
}

/**
 * @generated from enum search.v2.ResultType
 */
export type ResultTypeJson = "RESULT_TYPE_UNSPECIFIED" | "RESULT_TYPE_SUITE" | "RESULT_TYPE_CONTACT";

/**
 * Describes the enum search.v2.ResultType.
 */
export const ResultTypeSchema: GenEnum<ResultType, ResultTypeJson> = /*@__PURE__*/ enumDesc(file_search_v2_search, 0);

/**
 * @generated from service search.v2.SearchService
 */
export const SearchService: GenService<{
	/**
	 * @generated from rpc search.v2.SearchService.Search
	 */
	search: {
		methodKind: "unary";
		input: typeof SearchRequestSchema;
		output: typeof SearchResponseSchema;
	};
	/**
	 * @generated from rpc search.v2.SearchService.Autocomplete
	 */
	autocomplete: {
		methodKind: "unary";
		input: typeof AutocompleteRequestSchema;
		output: typeof AutocompleteResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_search_v2_search, 0);
